export const lmsUserLeadSchema = {
	title: 'LMS User Lead schema',
	description: 'create a LMS User Lead schema',
	version: 1,
	primaryKey: 'app_id_c',
	type: 'object',
	properties: {
		id: {
			type: 'string',
			maxLength: 250,
		},
		name: {
			type: 'string',
		},
		phone: {
			type: 'string',
		},
		app_id_c: {
			type: 'string',
			maxLength: 250,
		},
		added_by: {
			type: 'string',
		},
		assigned_cmdi: {
			type: 'string',
		},
		competition_tag: {
			type: 'boolean',
		},
		contractor_potential_per_month: {
			type: ['string', 'null'],
			nullable: true,
		},
		createddate: {
			type: 'string',
			format: 'date-time',
		},
		lastmodifieddate: {
			type: 'string',
			format: 'date-time',
		},
		lead_status: {
			type: 'string',
		},
		mdicode: {
			type: 'string',
		},
		non_end_category_c: {
			type: ['string', 'null'],
			nullable: true,
		},
		referral_source_c: {
			type: ['string', 'null'],
			nullable: true,
		},
		source: {
			type: 'string',
		},
		status: {
			type: 'string',
		},
		glue_consumption_per_month: {
			type: ['number', 'null'],
			nullable: true,
		},
	},

	required: ['id', 'name', 'phone', 'createddate', 'assigned_cmdi'],
};
